import { AddToCartProductInput } from '@Generated/graphql'

/**
 * Removes one entry from an add-to-cart input (e.g. a declined engraving child),
 * dropping its children with it and remapping the remaining entries'
 * parentIndex/groupIndex position references.
 */
export const removeAddToCartInput = (
  products: AddToCartProductInput[],
  index: number,
): AddToCartProductInput[] => {
  // Iterate to a fixed point so descendants are caught regardless of input order.
  const removed = new Set<number>([index])
  let previousSize = 0
  while (previousSize !== removed.size) {
    previousSize = removed.size
    products.forEach((item, position) => {
      if (typeof item.parentIndex === 'number' && removed.has(item.parentIndex)) {
        removed.add(position)
      }
    })
  }

  // A position reference shifts down by the number of removed entries before it.
  const shift = (position: number) => position - [...removed].filter(r => r < position).length

  return products
    .filter((_, position) => !removed.has(position))
    .map(item => ({
      ...item,
      ...typeof item.parentIndex === 'number' && { parentIndex: shift(item.parentIndex) },
      ...typeof item.groupIndex === 'number' && item.groupIndex >= 0 && { groupIndex: shift(item.groupIndex) },
    }))
}
